/* eslint-disable */
const slugify = require('slugify');

module.exports.toSlug = (title) => slugify(title, { lower: true });
